import type { ICommissionItemAttributeBaseSchema } from '@modules/affiliate-program-commissions/submodules/edit/types';
import type { PickStatus } from '@modules/core/enums';
import type { IFormPlainDataListboxItem } from '@modules/forms/types';

export enum EWebhookUriOptionFields {
  VALUE = 'value',
  KEY = 'key',
  DESCRIPTION = 'description',
}

export interface IPostbackUriOption {
  aasm_state: PickStatus<'DEFAULT' | 'CUSTOM'>;
  active: boolean;
  created_at?: string;
  [EWebhookUriOptionFields.DESCRIPTION]?: string;
  id?: number;
  [EWebhookUriOptionFields.KEY]?: string;
  updated_at?: string;
  [EWebhookUriOptionFields.VALUE]?: string;
  webhook_id?: number;
  affiliateId?: number;
  postbackId?: number;
  errors?: string[];
}

export interface IPostbackWebhook {
  active: boolean;
  build: boolean;
  id: number;
  kind: string;
  merchant_id: number;
  request_method?: string;
  success_confirmation: boolean;
  uri?: string;
  affiliateId?: number;
}

export interface IPostbackWebhookSaveResponse {
  webhook: IPostbackWebhook;
}

export interface IPostbackCondition extends ICommissionItemAttributeBaseSchema {
  id?: number;
  webhook_id?: number;
  created_at?: string;
  updated_at?: string;
  affiliateId?: number;
  postbackId?: number;
}

export interface IPostbackGetResponse {
  conditions?: IPostbackCondition[];
  condition_options?: {
    condition_for_comparison?: Record<string, string[]>;
    obtained_result?: Record<string, string>;
  };
  request_methods: string[];
  serial_ids: IFormPlainDataListboxItem<number>[];
  uri_options: IPostbackUriOption[];
  webhook: IPostbackWebhook;
}

export interface IPostbackTrackerEditPayload {
  value: number | string;
  search?: string;
  affiliateId?: number;
  id?: number;
  addType: string;
}

export interface IPostbacksConditionsSaveResponse {
  condition: IPostbackCondition;
}

export interface IPostbacksUriOptionsSaveResponse {
  uri_option: IPostbackUriOption;
}
